(function () {
	function swiperInit(isUpdate = false) {
		if (typeof subSliderInit === 'function') {
			subSliderInit(isUpdate);
		}

		if (typeof sliderInit === 'function') {
			sliderInit(isUpdate);
		}
	}

	if (document.documentElement.dataset.updateSliderBound === 'true') {
		return;
	}

	document.documentElement.dataset.updateSliderBound = 'true';

	document.addEventListener('shopify:section:load', function () {
		swiperInit(true);
	});

	swiperInit(false);
})();
